// src/services/fileService.js
import apiClient from './apiClient';

const API_BASE_URL = '/files';

const fileService = {
  // Upload a new file
  async uploadFile(formData) {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw new Error(error.response?.data?.message || 'Failed to upload file');
    }
  },

  // Get file metadata by ID
  async getFileById(fileId) {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching file details:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch file details');
    }
  },

  // Get file download URL
  getFileDownloadUrl(fileId) {
    console.log('File download URL:', `${apiClient.defaults.baseURL}${API_BASE_URL}/download/${fileId}`);
    return `${apiClient.defaults.baseURL}${API_BASE_URL}/download/${fileId}`;
  },

  // Get list of files based on filters
  async getFilesList(filters = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      // Add filters to query parameters
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
      
      const queryString = queryParams.toString();
      const url = `${API_BASE_URL}/list${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching files list:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch files list');
    }
  },

  // Delete a file
  async deleteFile(fileId) {
    try {
      const response = await apiClient.delete(`${API_BASE_URL}/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting file:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete file');
    }
  },

  // Update file metadata
  async updateFileMetadata(fileId, metadata) {
    try {
      const response = await apiClient.put(`${API_BASE_URL}/${fileId}`, metadata);
      return response.data;
    } catch (error) {
      console.error('Error updating file metadata:', error);
      throw new Error(error.response?.data?.message || 'Failed to update file metadata');
    }
  },

  // Replace an existing file
  async replaceFile(fileId, formData) {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/replace/${fileId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error replacing file:', error);
      throw new Error(error.response?.data?.message || 'Failed to replace file');
    }
  }
};

export default fileService;